import React from 'react'
import ContentLoader from 'react-content-loader'

const Loader = () => {
  return (
    <ContentLoader
      speed={2}
      width={1464}
      height={859}
      viewBox='0 0 1464 859'
      backgroundColor='#f3f3f3'
      foregroundColor='#ecebeb'
    >
      <>
        <rect x='14' y='27' rx='3' ry='3' width='185' height='22' />
        <rect x='217' y='22' rx='7' ry='7' width='70' height='20' />
        <rect x='300' y='24' rx='3' ry='3' width='12' height='17' />
        <rect x='317' y='26' rx='3' ry='3' width='250' height='14' />
        <rect x='757' y='15' rx='3' ry='3' width='120' height='35' />
        <rect x='887' y='15' rx='3' ry='3' width='73' height='35' />
        <rect x='970' y='15' rx='3' ry='3' width='84' height='35' />
        <rect x='1064' y='15' rx='3' ry='3' width='97' height='35' />
        <rect x='1171' y='15' rx='3' ry='3' width='111' height='35' />
        <rect x='1292' y='15' rx='3' ry='3' width='147' height='35' />

        <rect x='15' y='70' rx='3' ry='3' width='178' height='128' />
        <rect x='222' y='88' rx='3' ry='3' width='270' height='12' />
        <rect x='222' y='141' rx='3' ry='3' width='67' height='10' />
        <rect x='328' y='141' rx='3' ry='3' width='77' height='10' />
        <rect x='222' y='167' rx='3' ry='3' width='45' height='17' />
        <rect x='252' y='169' rx='3' ry='3' width='12' height='7' />
        <rect x='328' y='167' rx='3' ry='3' width='45' height='10' />

        <rect x='15' y='248' rx='3' ry='3' width='174' height='15' />

        <rect x='47' y='310' rx='3' ry='3' width='100' height='10' />
        <rect x='260' y='310' rx='3' ry='3' width='55' height='10' />
        <rect x='430' y='310' rx='3' ry='3' width='43' height='10' />
        <rect x='544' y='310' rx='3' ry='3' width='59' height='30' />
        <rect x='647' y='310' rx='3' ry='3' width='48' height='30' />
        <rect x='739' y='310' rx='3' ry='3' width='81' height='30' />
        <rect x='868' y='310' rx='3' ry='3' width='105' height='30' />
        <rect x='1023' y='310' rx='3' ry='3' width='85' height='10' />
        <rect x='1155' y='310' rx='3' ry='3' width='115' height='30' />
        <rect x='1326' y='310' rx='3' ry='3' width='105' height='30' />

        <rect x='47' y='383' rx='3' ry='3' width='100' height='10' />
        <rect x='237' y='383' rx='3' ry='3' width='100' height='10' />
        <rect x='414' y='383' rx='3' ry='3' width='75' height='10' />
        <rect x='528' y='383' rx='3' ry='3' width='90' height='10' />
        <rect x='762' y='383' rx='3' ry='3' width='34' height='10' />
        <rect x='883' y='383' rx='3' ry='3' width='75' height='10' />
        <rect x='1048' y='383' rx='3' ry='3' width='35' height='10' />

        <rect x='295' y='430' rx='3' ry='3' width='40' height='10' />
        <rect x='762' y='430' rx='3' ry='3' width='33' height='10' />
        <rect x='883' y='430' rx='3' ry='3' width='75' height='10' />
        <rect x='1048' y='430' rx='3' ry='3' width='35' height='10' />
        <rect x='1177' y='430' rx='3' ry='3' width='71' height='10' />
        <rect x='1343' y='430' rx='3' ry='3' width='71' height='10' />

        <rect x='35' y='530' rx='3' ry='3' width='70' height='10' />
        <rect x='145' y='530' rx='3' ry='3' width='57' height='10' />

        <rect x='14' y='581' rx='3' ry='3' width='130' height='12' />

        <rect x='30' y='631' rx='3' ry='3' width='12' height='8' />
        <rect x='50' y='629' rx='3' ry='3' width='130' height='14' />
        <rect x='1320' y='629' rx='3' ry='3' width='120' height='14' />

        <rect x='14' y='688' rx='3' ry='3' width='90' height='12' />

        <rect x='30' y='739' rx='3' ry='3' width='12' height='8' />
        <rect x='50' y='737' rx='3' ry='3' width='130' height='14' />
        <rect x='1320' y='737' rx='3' ry='3' width='120' height='14' />

        <rect x='30' y='806' rx='3' ry='3' width='12' height='8' />
        <rect x='50' y='804' rx='3' ry='3' width='130' height='14' />
        <rect x='1320' y='804' rx='3' ry='3' width='120' height='14' />
      </>
    </ContentLoader>
  )
}

export default Loader